// The AI sessions (transcript/summary) page requires both the AI interpreter
// feature and transcription/summary to be enabled (TUL-5362). The backend folds
// the customer-level and usergroup-level AI interpreter flags into
// userGroup.allowAiInterpreter.
export const isAiSessionsEnabled = (user) =>
  !!(user?.userGroup?.allowAiInterpreter && user?.userGroup?.allowTranscriptionSummary);
